// extracted by mini-css-extract-plugin
export default {"for-creators":"styles_for-creators__O0d6E","for-creators__content":"styles_for-creators__content__RQ8BC","for-creators__buttons":"styles_for-creators__buttons__KzJ1k"};